import React from 'react'

function Loader() {
  return (
    <div id="preloader"></div>
  );
}
export default Loader;